import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";

export default class BankingService extends ApiService {
  namespace = "processing";
  DOMAIN = 177;
  name = "Associate";
  template = "defaultTemplate";
  Width = 900;
  icon = "Checks";
  action = "action";

  gemItems = [
    {
      key: "create",
      label: "Create Check",
      icon: "Plus",
      services: -57,
    },
    {
      key: "loader",
      label: "Transfer Funds",
      icon: "Briefcase",
      services: DOMAIN.WORK_ORDER,
    },
    {
      key: "loader",
      label: "Reconcile an Account",
      icon: "Document",
      services: 157,
    },
    {
      key: "create",
      label: "Add Check Layout",
      icon: "Calendar",
      services: -58,
    },
    {
      key: "listing",
      label: "All Checks",
      icon: "Plus",
      services: -57,
    },
    {
      key: "listing",
      label: "Print Queue",
      icon: "Bullets",
      services: -57,
    },
    {
      key: "loader",
      label: "All Transfers",
      icon: "Bullets",
      services: DOMAIN.DEPOSIT,
    },
    {
      key: "loader",
      label: "All Reconciliations",
      icon: "Bullets",
      services: DOMAIN.DEPOSIT,
    },
    {
      key: "listing",
      label: "All Check Layouts",
      icon: "Bullets",
      services: -58,
    },
  ];

  constructor() {
    super("processing");
  }
}
